<template>
  <forms v-if="value"
        title=""
        :showSaveButton="true"
        :showClearButton="true"
        @Clear="onClearAdditive"
        @Save="onSave"
        class="animated fadeIn fadeOut d-flex flex-wrap col-12">

    <div class="d-flex flex-wrap col-12">
      <div class="col-1" mb-3>
        <label for="txtItem">Item:</label>
        <b-input id="txtItem"
                autofocus
                v-model="form.sequencia.value"
                :required="form.sequencia.required"
                :state="form.sequencia.state"></b-input>
      </div>
      <div class="col-5 mb-3">
        <label for="txtDescricao">{{$lang.PCI.Lpu.LabelDescription}}:</label>
        <b-input id="txtDescricao"
                v-model="form.descricao.value"
                :required="form.descricao.required"
                :state="form.descricao.state"></b-input>
      </div>
      <div class="col-2 mb-3">
        <label for="txtUnidade">{{$lang.PCI.Lpu.LabelUnity}}:</label>
        <b-input id="txtUnidade"
                v-model="form.unidade.value"
                :required="form.unidade.required"
                :state="form.unidade.state"></b-input>
      </div>
      <div class="col-2 mb-3">
        <label for="txtValor">{{$lang.PCI.AT.LabelValue}}:</label>
        <b-input id="txtValor"
                type="number"
                v-model="form.valor.value"
                :required="form.valor.required"
                :state="form.valor.state"></b-input>
      </div>
      <div class="col-2 mb-3">
        <label for="txtQuantidade">{{$lang.PCI.AT.LabelQuantity}}:</label>
        <b-input id="txtQuantidade"
                type="number"
                v-model="form.quantidade.value"
                :required="form.quantidade.required"
                :state="form.quantidade.state"></b-input>
      </div>
      <div class="col-3 mb-3">
        <label for="txtCodigoCliente">{{$lang.PCI.Lpu.LabelClientCode}}:</label>
        <b-input id="txtCodigoCliente"
                v-model="form.codigoCliente.value"
                :required="form.codigoCliente.required"
                :state="form.codigoCliente.state"></b-input>
      </div>
      <div class="col-9 mb-3">
        <label for="txtDescricaoCliente">{{$lang.PCI.Lpu.LabelClientDescription}}:</label>
        <b-input id="txtDescricaoCliente"
                v-model="form.descricaoCliente.value"
                :required="form.descricaoCliente.required"
                :state="form.descricaoCliente.state"></b-input>
      </div>
      <div class="col-12 mb-3">
        <label for="txtObservacao">{{$lang.PCI.Lpu.LabelObservation}}:</label>
        <b-textarea id="txtObservacao"
                    rows="3"
                    v-model="form.observacao.value"
                    :required="form.observacao.required"
                    :state="form.observacao.state"></b-textarea>
      </div>
    </div>
  </forms>
</template>

<script>
import gridMixin from '../../mixins/gridMixin'
import actionsForm from '@/shared/mixins/actionsForm'
import { AgGridVue } from 'ag-grid-vue'
import Data from '@/shared/models/pci/tecanalysisitemmodel'
import Form from './additive-form'
import Forms from '@/components/forms/Forms.vue'

export default {
  name: 'Additive',
  mixins: [gridMixin, actionsForm],
  components: {
    AgGridVue,
    Forms
  },
  props: {
    value: {
      type: Object
    },
    list: {
      type: Array,
      require: true
    },
    columnDefs: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      data: Data,
      form: Form
    }
  },
  computed: {
    newAdditive () {
      return {
        id: this.value.id,
        analiseTecID: this.value.analiseTecID,
        origemItem: this.value.origemItem,
        lpuItemID: null,
        ordem: this.value.ordem,
        sequencia: this.data.sequencia,
        descricao: this.data.descricao,
        tipoItem: this.data.tipoItem,
        tipoAgrupamento: this.data.tipoAgrupamento,
        analiseTecItemDetalhe: {
          id: this.value.analiseTecItemDetalhe.id,
          analiseTecItemID: this.value.id,
          valor: this.data.valor,
          unidade: this.data.unidade,
          codigoCliente: this.data.codigoCliente,
          descricaoCliente: this.data.descricaoCliente,
          observacao: this.data.observacao,
          quantidade: this.data.quantidade
        }
      }
    }
  },
  methods: {
    onLoad () {
      if (this.value) {
        this.loadData(this.value)
        this.onEdit(this.data)
      }
    },
    onClearAdditive () {
      this.onClear()
      this.$emit('Clear')
    },
    onCreate () {
      this.$emit('Create', this.newAdditive)
      this.onClearAdditive()
    },
    onUpdate () {
      this.$emit('Update', this.newAdditive)
      this.onClearAdditive()
    },
    loadData (obj) {
      this.data = {
        id: obj.id,
        analiseTecID: obj.analiseTecID,
        origemItem: obj.origemItem,
        ordem: obj.ordem,
        sequencia: obj.sequencia,
        descricao: obj.descricao,
        tipoItem: obj.tipoItem,
        tipoAgrupamento: obj.tipoAgrupamento,
        valor: obj.analiseTecItemDetalhe.valor,
        unidade: obj.analiseTecItemDetalhe.unidade,
        codigoCliente: obj.analiseTecItemDetalhe.codigoCliente,
        descricaoCliente: obj.analiseTecItemDetalhe.descricaoCliente,
        quantidade: obj.analiseTecItemDetalhe.quantidade,
        observacao: obj.analiseTecItemDetalhe.observacao,
        status: 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/tecanalysis/additive.vue